// extracted by mini-css-extract-plugin
export default {"container":"tx-bogh3nI","uplink":"-8KrIR3ojz","downlink":"_0rT7jJekPq","policy":"isKmxpJ-rN","icon":"yJULPK9-2y"};